module.exports = __webpack_public_path__ + "static/media/wave03.c7f9051b.webp";